
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageTemplate } from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import InputEmojiSelector from '@/components/common/ui/InputEmojiSelector.vue'
import UploadApi from '@/api/upload'
import { ACTION_FLEX_MESSAGE_TEMPLATE } from '@/store/actions'
import TagInputContent from '@/components/common/ui/TagInputContent.vue'
import FlexMessageTemplateEditModal from '@/components/story/common/flex-message/FlexMessageTemplateEditModal.vue'

@Options({
  components: { FlexMessageTemplateEditModal, TagInputContent, InputEmojiSelector, CLoading },
  directives: { maska },
  emits: ['update:closeModal', 'updateTemplates'],
})
export default class FlexMessageTemplateFormModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  template!: IFlexMessageTemplate

  @Prop()
  previewImageUrl!: string

  @Prop()
  imgFile!: File

  @Prop()
  appId!: string

  @Prop()
  isMessageChanged!: boolean

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  type!: string

  @Prop()
  altText!: string

  loading = false
  templateModalVisible = false
  isTemplateChanged = false
  messageImg: File | null = null
  messageImgUrl: string | null = null
  currentAltText = ''
  form: IFlexMessageTemplate = {
    _id: '',
    app_id: this.appId,
    name: '',
    img: '',
    description: '',
    type: 'bubble',
    is_video: false,
    is_image: true,
    is_button: false,
    contents: {},
    alt_text: '',
  }

  get templateType() {
    if (this.form.contents) {
      return this.form.contents.type
    }
    return this.form.type
  }

  get presenceVideo() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'video')
    }
    return false
  }

  get presenceImage() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'image')
    }
    return false
  }

  get presenceButton() {
    if (this.form.contents) {
      return this.containsType(this.form.contents, 'button')
    }
    return false
  }

  get requiredRule() {
    return {
      templateId: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.display_id'),
      }),
      templateName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.flex_message_template.template_name'),
      }),
    }
  }

  editTemplate() {
    this.templateModalVisible = true
  }

  onCloseModal() {
    this.templateModalVisible = false
  }

  onCaptureMessage(file: File, url: string) {
    this.messageImg = file
    this.messageImgUrl = url
    this.isTemplateChanged = true
  }

  async doSave() {
    this.form.type = this.templateType
    this.form.is_video = this.presenceVideo
    this.form.is_image = this.presenceImage
    this.form.is_button = this.presenceButton
    if (this.form._id === '' || this.isMessageChanged || this.form.img === '' || this.isTemplateChanged) {
      try {
        if (this.messageImg) {
          const uploaded = await UploadApi.uploadFile(this.messageImg)
          if (uploaded && uploaded.file_url_org) {
            this.form.img = uploaded.file_url_org
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    let success
    if (this.form._id === '') {
      if (this.isSuper) {
        this.form.template_type = this.type
      } else {
        this.form.template_type = 'custom'
      }
      success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.ADD, {
        ...this.form,
      })
    } else {
      success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.UPDATE, {
        ...this.form,
      })
    }
    if (success) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
      this.$emit('updateTemplates')
    }
  }

  onSubmit() {
    try {
      this.$refs.formRef
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            return
          }
          this.loading = true
          await this.doSave()
          this.loading = false
          this.visible = false
        })
        .catch((error: unknown) => {
          console.log('error', error)
        })
    } catch (error) {
      console.log('error', error)
    }
  }

  containsType(obj, type) {
    if (typeof obj !== 'object' || obj === null) return false

    if (Array.isArray(obj)) {
      return obj.some((item) => this.containsType(item, type))
    }

    for (const key in obj) {
      if (key === 'type' && obj[key] === type) {
        return true
      }

      if (typeof obj[key] === 'object') {
        if (this.containsType(obj[key], type)) {
          return true
        }
      }
    }

    return false
  }

  @Watch('imgFile', { immediate: true })
  getMessageImg() {
    this.messageImg = this.imgFile
    this.messageImgUrl = this.previewImageUrl
  }

  created() {
    this.currentAltText = cloneDeep(this.altText)
    this.form = { ...this.form, ...cloneDeep(this.template) }
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
    this.$nextTick(() => {
      this.$refs.formRef.validate()
    })
  }
}
